<template>
      <v-form ref="formFavoriteContacts" v-model="formFavoriteContacts">
        <p class="text-h5">{{ languageData.favoriteContacts }}</p>
        <div class="row justify-center">          
            <div class="col-6">
                <v-text-field
                    outlined
                    :label="languageData.labels.firstname"
                    v-model="favoriteContact.firstname"
                    :rules="rules.firstname"
                >
                </v-text-field>
            </div>
            <div class="col-6">
                <v-text-field
                    outlined
                    :label="languageData.labels.lastname"
                    v-model="favoriteContact.lastname"
                    :rules="rules.lastname"
                >
                </v-text-field>
            </div>
        </div>
        <v-text-field
            outlined
            :label="languageData.labels.email"
            v-model="favoriteContact.email"
            :rules="rules.email"
        >
        </v-text-field>
        <v-text-field
            outlined
            :label="languageData.labels.phone"
            v-model="favoriteContact.phone"
            :rules="rules.phone"
        >
        </v-text-field>
        <v-textarea
            class="mt-5"
            outlined
            :rules="rules.description"
            :label="languageData.labels.description"
            v-model="favoriteContact.description"
            rows="6">
        </v-textarea>
        <v-btn color="primary"
               @click="addOrUpdateFavoriteContact"
               :loading="dataSaveIsFetching"
        >
          {{ languageData.btnSave }}
        </v-btn>
      </v-form>
</template>


<script type="text/javascript">

import { mapActions, mapState } from "vuex";
import eventBus from "../../../../event-bus/eventBus";
import handleFormError from "../../../../helpers/handleFormError";

export default {
  name: "FavoriteContactForm",
  props: {
    layout: String
  },
  data() {
    return {
      favoriteContact : {
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        description: ''
      },
      formFavoriteContacts: false,
      validForm: false,
      rules: {},
      favoriteContactId: null
    }
  },
  computed: {
    ...mapState("saveFavoriteContact", {
      dataSaveIsFetching: state => state.dataSaveIsFetching,
      textInfoFavoriteContactSave: state => state.textInfoFavoriteContactSave,
      typeInfoFavoriteContactSave: state => state.typeInfoFavoriteContactSave,
      headInfoFavoriteContactSave: state => state.headInfoFavoriteContactSave,
      isFavoriteContactSave: state => state.isFavoriteContactSave,
    })
  },
  methods: {
    ...mapActions("saveFavoriteContact", ["storeFavoriteContact", "updateVisibleModalFavoriteContact"]),
    ...mapActions("getFavoriteContact", ["getFavoriteContact"]),

    addOrUpdateFavoriteContact: function() {
      let data = this.favoriteContact;
      data.id = this.favoriteContactId;
      this.rules = {};
      this.$refs.formFavoriteContacts.resetValidation();
      this.storeFavoriteContact({ creds: { data } });
    },
    hideFavoriteContactModal() {
      this.updateVisibleModalFavoriteContact(false);
    },
    clearForm() {
      this.favoriteContact = {
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        description: ''
      };
    }
  },
  mounted() {
    eventBus.$on("saveFavoriteContactSuccess", () => {
      this.clearForm();
      if(this.favoriteContactId !== null) {
        this.updateVisibleModalFavoriteContact(false);
      }
    });
    eventBus.$on("saveFavoriteContactFailure", (errorsReceive) => {
      this.rules = handleFormError(errorsReceive);
      this.validForm = this.$refs.formFavoriteContacts.validate();
    });
    eventBus.$on("setFavoriteContactId", (id) => {
      if(id === null) {
        if(this.favoriteContactId !== null) {
          this.clearForm();
        }
      } else {
        this.getFavoriteContact(id);
      }
      this.favoriteContactId = id;
    });
    eventBus.$on("setFavoriteContactFormData", (data) => {
      this.favoriteContact = data;
    });
  }
}
</script>